<template>
  <pt-work-order-history class="pt-work-order-history__withData"></pt-work-order-history>
</template>

<script>
import PtWorkOrderHistory from './index'
export default {
  name: 'pt-work-order-history__withData',
  components: {
    'pt-work-order-history': PtWorkOrderHistory
  }
}
</script>
